// extracted by mini-css-extract-plugin
export default {"player":"ExerciseYouTubePlayer_player__XGVND","iframe":"ExerciseYouTubePlayer_iframe__NZAaX","empty":"ExerciseYouTubePlayer_empty__A13Q7"};